export const UEC_NAME = 'uec'
